import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentClass: 0, // 当前分类
  },
  mutations: {
    setCurrentClass(state, classIndex) {
      state.currentClass = classIndex
    },
  },
})
